export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6690.13ad3a37.jpg";